import { render, staticRenderFns } from "./Each_Parasite.vue?vue&type=template&id=416ec3fc&scoped=true"
import script from "./Each_Parasite.vue?vue&type=script&lang=js"
export * from "./Each_Parasite.vue?vue&type=script&lang=js"
import style0 from "./Each_Parasite.vue?vue&type=style&index=0&id=416ec3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ec3fc",
  null
  
)

export default component.exports